import { useState, useEffect } from 'react';
import axios from 'axios';

const useWebsiteSettings = () => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/website-settings');
      setSettings(response.data);
      setError(null);
    } catch (error) {
      console.error('Error fetching website settings:', error);
      setError('Failed to load website settings');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return { settings, loading, error, refetch: fetchSettings };
};

export default useWebsiteSettings;